import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, intro, align = "left", light = false, testId }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <p className={`eyebrow mb-4 ${light ? "!text-en-yellow" : ""}`}>{eyebrow}</p>}
    <h2 data-testid={testId} className={`font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] ${light ? "text-white" : "text-black"}`}>
      {title}
    </h2>
    {intro && <p className={`mt-5 text-base sm:text-lg leading-relaxed ${light ? "text-white/80" : "text-black/70"}`}>{intro}</p>}
  </Reveal>
);
